import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
// import 'element-ui/lib/theme-default/index.css'
// import './assets/theme/theme-darkblue/index.css'
import * as echarts from 'echarts'
import 'echarts-gl'
import VueRouter from 'vue-router'
import store from './vuex/store'
import Vuex from 'vuex'
//import NProgress from 'nprogress'
//import 'nprogress/nprogress.css'
import routes from './routes'
// import Mock from './mock'
// Mock.bootstrap();
import 'font-awesome/css/font-awesome.min.css'
import * as VueHelper from './helper/VueHelper';
import * as Events from './helper/Events';
import * as Urls from './helper/Urls';
import MenuUtils from '@/utils/MenuUtils';
// 引入自定义指令
import './helper/directives.js';
import moment from 'moment'
// axios.defaults.withCredentials = true
import '../config/axios'
//ajax引入
import {proxy, unProxy} from "ajax-hook";
import Rem from '@/utils/rem';
// import Vant from 'vant';
import { Checkbox, CheckboxGroup, Dialog, Popup } from 'vant';
import 'vant/lib/index.css';

Vue.prototype.$echarts = echarts
Vue.prototype.$moment = moment
import XmDialog from './components/xmDialog'
Vue.$XmDialog = Vue.prototype.$XmDialog = XmDialog.install
// Vue.use(Vant);
proxy({
    //请求发起前进入
    onRequest: (config, handler) => {
        //下面是针对两种上传做的处理
        //监控模块不需要加authorization
        if(config.headers.authorization || config.url.indexOf("play.xmoty.com/xmlive") != -1){

        }else{
            config.headers.authorization = window.sessionStorage.getItem('token');
        }
        
        handler.next(config);
    },
    //请求发生错误时进入，比如超时；注意，不包括http状态码错误，如404仍然会认为请求成功
    onError: (err, handler) => {
        // console.log(err.type)
        handler.next(err)
    },
    //请求成功后进入
    onResponse: (response, handler) => {
        // console.log('response',response)
        handler.next(response)
    }
}),




Vue.use(ElementUI);
Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(echarts);
Vue.use(Popup);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(echarts)

//NProgress.configure({ showSpinner: false });

//router.afterEach(transition => {
//NProgress.done();
//});

// ========= 路由类
const router = new VueRouter({
  routes
})


if(window.location.hash != '#/login'){
    let data = JSON.parse(window.sessionStorage.getItem('userPre'))
    if (data){
        //这里是防止用户手动刷新页面，整个app要重新加载,动态新增的路由，会消失，所以我们重新add一次
        let routes = []
        MenuUtils(routes,data)
        router.addRoutes(routes)
        console.log(routes, '--------------------')
    }
}


let benchBtns = [],benchId;
router.beforeEach((to, from, next) => {
     // chrome
     document.body.scrollTop = 0
     // firefox
     document.documentElement.scrollTop = 0
     // safari
     window.pageYOffset = 0

     let isH5 = to.path == '/fileh5' || to.path == '/h5upload' || to.path == '/JournalFileh5' || to.path == '/CommonUploadH5' || to.path == '/operationDataH5' || to.path == '/pdfViewH5' || to.path == '/businessInfoH5';

     let isScreen = to.path === '/datav/index' || to.path === '/datavIndex' || to.path === '/bizCompasition' || to.path === '/datav/biz' || to.path === '/datav/pm' || to.path ==='/datav/project' || to.path ==='/datav/customer' ||  to.path === '/forgotPassword'
    if (to.path == '/login') {
        console.log('登录/login')
        sessionStorage.removeItem('user');
        next()
    }else if(to.path == '/appLogin' || to.path.startsWith('/appLogin')){
        let user = JSON.parse(sessionStorage.getItem('user'));
        Vue.prototype.$wxOpenId = user&&user.wxOpenId  ? false : true
        document.getElementById('meta').content = 'width=device-width,initial-scale=1.0'
        next()
    }else if(isH5){
        document.getElementById('meta').content = 'width=device-width,initial-scale=1.0,user-scalable=no'
        next()
    }else{
        let user = JSON.parse(sessionStorage.getItem('user'));
        Vue.prototype.$wxOpenId = user&&user.wxOpenId  ? false : true
        // if (!user && to.path != '/login') {next({ path: '/login' })}
        if(!user && to.path != '/login'){
            if(isScreen){
                next()
            } else {
                next({path: '/login'})
            }
        }
        else {
            let userInfo = JSON.parse(sessionStorage.getItem('user'));
            let roleMeun = userInfo.roleMeun;
            try {
                let inst = this;
                roleMeun.forEach(element => {
                    element.children.forEach(element2 => {
                        if(element2.children.length){//菜单有三级
                            element2.children.forEach(element3 => {
                                if(element3.workBenchList[0].benchPath == to.path){
                                    benchBtns = element3.workBenchList[0].benchBtns;
                                    benchId = element3.benchId;
                                    store.commit('setParam', element3.workBenchList[0].benchParam);
                                    store.commit('setBenchId', element3.benchId);
                                    throw Error();
                                }
                            });
                        }else{//菜单有二级
                            if(element2.workBenchList[0].benchPath == to.path){
                                benchBtns = element2.workBenchList[0].benchBtns;
                                benchId = element2.benchId;
                                store.commit('setParam', element2.workBenchList[0].benchParam);
                                store.commit('setBenchId', element2.benchId);
                                throw Error();
                            }
                        }
                    });
                });
            }catch (e) {}
            document.getElementById('meta').content = ''
            next()
        }

        
    }
    
}) 

router.onError((error) => {
   
    const pattern = /Loading chunk (\d)+ failed/g;
    const isChunkLoadFailed = error.message.match(pattern);
    const targetPath = router.history.pending.fullPath;
    if (isChunkLoadFailed) {
        router.replace(targetPath);
    }
   
});

// ========= 全局消息设置
var Bus = new Vue();

import axios from 'axios';
axios.defaults.withCredentials = true

var enumMap = {};
//金额格式,每隔三位加逗号
Vue.filter('money', function(value) {
    if(!value) return '0.00';
    let result = 0;
    if(typeof value == 'string'){
        result = parseFloat(value).toFixed(2);
        // if(typeof result !=Number){    
        //     return value;
        // }
    }else{
        result = value.toFixed(2);
        
    }
   
    var value2Array = result.split(".");
    var intPart = value2Array[0];
    var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断
    var floatPart = ".00";
    floatPart = value2Array[1];
    return intPartFormat + '.' + floatPart;
  });
  //万元金额格式；
  Vue.filter('w_money', function(val) {
    if (!val) return '0.00';
    let result = 0;
    if(typeof val == 'string'){
        result = parseFloat(val).toFixed(2);
    }else{
        result = val.toFixed(2);
    }
    return (result / 10000).toFixed(2);
  });
new Vue({
  //el: '#app',
  //template: '<App/>',
  router,     
  store,
  //components: { App }
  data: {
      Bus, 
      enumMap,
      benchId:'',//当前菜单benchId

  },
  methods: {
    getBenchBtns(){
        return benchBtns
    },
    isGet(tag){
        let flag = false;
        benchBtns.forEach(e => {
            if(tag == e.btnCode || tag == e.btnValue){
                flag = true;
            }
        })
        return flag;
    },
    getbenchId(){
        return benchId;
    },
      // ======== 加入方便的根方法
    doPost: function(url,params, succ_func, error_func,noLoading){
          
        let theParams = null;
        if(params){
              theParams = VueHelper.makeSearchParams(params);
          }
        let inst = this;
        let loading;
        if(!noLoading){
            loading = this.$loading({
                lock: true,
                text: '',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0)',
                customClass:'loading-custom',
                fullscreen:false
            });
        }
        axios.post(url, theParams).then(function (response) {
                  
            let server_data = response.data;
            succ_func(server_data);
            if(loading)loading.close();
        })
        .catch(function (error) {	
            if(loading)loading.close();
            if(error_func){
                error_func(error);
            }else{
                console.log('=================== error ===============');
                console.log('请求失败', error);
                // inst.$message.error('网络不可用或应用程序出错');
            }
          
        });
    }, 
    doGet: function(url,params, succ_func, error_func,noLoading){

        let inst = this;
        
        let theParams = null;
        if(params){
            theParams = {params};
        }
        let loading;
        if(!noLoading){
            loading = this.$loading({
                lock: true,
                text: '',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0)',
                customClass:'loading-custom',
                fullscreen:false
            });
        }
        axios.get(url, theParams).then(function (response) {
                  
            let server_data = response.data;
            succ_func(server_data);
            if(loading)loading.close();
        })
        .catch(function (error) {	
            if(loading)loading.close();
            if(error_func){
                error_func(error);
            }else{
                console.log('=================== error ===============');
                console.log('请求失败', error);
                inst.$message.error('网络不可用或应用程序出错');
            }
          
        });
    }, 
    doPut: function(url,params, succ_func, error_func){
          
        let theParams = null;
        if(params){
              theParams = VueHelper.makeSearchParams(params);
          }
        let inst = this;

        // console.log('---- check bus');
        // console.log(inst.Bus);

        axios.put(url, theParams).then(function (response) {
                  
            let server_data = response.data;
            succ_func(server_data);
        })
        .catch(function (error) {	
            if(error_func){
                error_func(error);
            }else{
                console.log('=================== error ===============');
                console.log('请求失败', error);
                // inst.$message.error('网络不可用或应用程序出错');
            }
          
        });
    }, 
    doDelete: function(url,params, succ_func, error_func){
          
        let theParams = null;
        if(params){
            theParams = VueHelper.makeSearchParams(params);
        }
        let inst = this;

        // console.log('---- check bus');
        // console.log(inst.Bus);

        axios.delete(url, theParams).then(function (response) {
            let server_data = response.data;
            succ_func(server_data);
        })
        .catch(function (error) {	
            if(error_func){
                error_func(error);
            }else{
                console.log('=================== error ===============');
                console.log('请求失败', error);
                // inst.$message.error('网络不可用或应用程序出错');
            }
          
        });
    }, 
    showGlobalError(text){
        this.$message.warning(text);
    }, 
    showGlobalSucc(text){
        this.$message.success(text);
    }, 
    isUserLogin(server_data){        
        // console.log('=================== not login ===============');
        // console.log(server_data);
        // 用户没有登录
        if('Y' == server_data.sessionExpire){
            // console.log('====== emit not login');
            // this.Bus.$emit(Events.GLOBAL_USER_NOT_LOGIN);//拦截接口未登录状态 发送事件触发唤起登录弹窗
            this.$router.push('/login')//登陆设备绑定管理优化 登录失效直接跳转登录页
            return false;
        }
        return true;
    }, 
    //时间格式化
    formatDate(data) {
        if(data){
            return moment(data).format("YYYY-MM-DD HH:mm:ss");
        }else{
            return '';
        }
        
    },
    //时间格式化
    formatDay(data) {
        if(data){
            return moment(data).format("YYYY-MM-DD");
        }else{
            return '';
        } 
    },
    formatDayNY(data){
        if(data){
            return moment(data).format("YYYY-MM");
        }else{
            return '';
        } 
    },
    //时间格式化
    formatTime(data) {
        if(data){
            return moment(data).format("HH:mm:ss");
        }else{
            return '';
        } 
    },
    // ===== 初始化枚举数据
    initEnumData(using_func){        
        let url = Urls.get_all_enum_data_map;
				
        let params = {
        }
        let inst = this;
        this.$root.doPost(url,params,function(server_data){
                
            // 用户没有登录
            if( ! inst.$root.isUserLogin(server_data)){
                return;
            }

            // 应用错误
            if(server_data.error){
                inst.$root.showGlobalError(server_data.error);
                return;
            }

            using_func(server_data.data);
        });
    }, 

    // ===== 更精简的ajax
    ajaxGet(url, params, using_func){        
        let inst = this;
        this.$root.doGet(url,params,function(server_data){
                
            // 用户没有登录
            if( ! inst.$root.isUserLogin(server_data)){
                return;
            }

            // 应用错误
            if(server_data.error){
                inst.$root.showGlobalError(server_data.error);
                return;
            }

            using_func(server_data.data);
        });
    }, 
    ajaxPost(url, params, using_func){        
        let inst = this;
        this.$root.doPost(url,params,function(server_data){
            
                
            // 用户没有登录
            if( ! inst.$root.isUserLogin(server_data)){
                return;
            }

            // 应用错误
            if(server_data.error){
                inst.$root.showGlobalError(server_data.error);
                return;
            }

            using_func(server_data.data);
        });
    }, 
    getLoginUser(){

        var user = sessionStorage.getItem('user');
        if (user) {
            user = JSON.parse(user);
        }
        return user;
    },
    notLoginforPrint(server_data){
        if('Y' == server_data.sessionExpire){
            this.$root.showGlobalError(server_data.error);
            setTimeout(()=>{
                if (navigator.userAgent.indexOf("Firefox") != -1 || navigator.userAgent.indexOf("Chrome") != -1) {
                    window.location.href = "about:blank";
                    window.close();
                 } else {
                    window.opener = null;
                    window.open("", "_self");
                    window.close();
                 }
            },500)
        }
    },
    gotoDetail(item){
        let path='';
        let query={bizItemId:item.bizItemId};
        switch(item.itemCat){
            case 'LABOR_APPLY':
                path = '/common/servicePayDetail'
                break;
            case 'RISK_ FUND_APPLY':
                path = '/common/RiskFundDetails'
                break;
            case 'ADVANCE_TAX_APPLY':
                path = '/common/refundTaxesDetails'
                break;
            case 'PAID_MATERIAL_APPLY':
                path = '/common/materialDetail'
                break;
            case 'PROPERTY_MANAGEMENT_APPLY':
                path = '/common/depositDetail'
                break;
            case 'BID_BOND_APPLY':
                path = '/common/marginDetail'
                break;
            case 'SEAL_APPLY':
                path = '/cm/sealApplicationDetail'
                break;
            case 'CONTRACT_APPLY':
                path = '/cm/contract/read_view0'
                break;
            case 'GUARANTEE_LETTER_APPLY':
                path = '/commonPage/projectManage/guaranteeDetail'
                break;
            case 'INSURANCE_APPLY':
                path = '/finance/insuranceDetail'
                break;
            case 'PUNISHMENT_APPLY':
                path = '/common/adminSanctionDetail'
                break;
            case 'LITIGATION_APPLY':
                path = '/common/litigationDetail'
                break;
            case 'COMPLAINT_APPLY':
                path = '/common/complaintDetail'
                break;
            case 'PROJECT_APPLY':
                path = '/common/proPreparationDetail'
                break;
            case 'CASUALTY_APPLY':
                path = '/common/injuriesDetail'
                break;
            case 'CREDIT_APPLY':
                path = '/common/creditDetail'
                break;
            case 'PROJECT_LOSE_SINGLE':
                path = '/commonPage/projectManage/losingDetailNew'
                break;
            case 'PROJECTMANAGER_APPLY'://精英库人员详情
                path = '/cd/pm/edit'
                break;
            case 'ADVANCETAXAPPLY_APPLY'://预缴税费
                path = '/fm/prepaidTaxDetail'
                break;
            case 'INVOICEAPPLYDATA_APPLY'://消项票
                path = '/fm/FmOutPutTicketDetail'
                break;
            case 'INVOICEAPPLYDATA_VOID'://作废
                path = '/fm/FMVoidRecordDetail'
                break;
            case 'INVOICEAPPLYDATA_REDRUSH'://红冲
                path = '/fm/FMVoidRecordDetail'
                query = {bizItemId:item.bizItemId,type:3,applyType:3}
                break;
            case 'COMPLETION_SETTLE_APPLY'://完工结算
                path = '/cm/CMFinishedAccountDetail'
                query = {bizItemId:item.bizItemId}
                break;
            case 'OTHER_SEAL_APPLY':
                path = '/cm/sealApplicationOtherDetail'
                query = {bizItemId:item.bizItemId}
                break;
            case 'TICKET_RECORDS':
                path = '/admin/WorkOrderDetail'
                query = {bizItemId:item.bizItemId}
                break;
        }
        if(!path)return;
        this.$router.push({ path: path, query: query});
    },
    isHas(code) {
        let btnGroup = JSON.parse(sessionStorage.getItem("user")).buttons;
        let buttons = btnGroup.map(item => item.btnValue || item.btnCode ).filter(Boolean);
        if (buttons.includes(code)) {
            return true;
        } else {
            return false;
        }
    }
  },
  render: h => h(App),
  beforeCreate(){
    Vue.prototype.$bus = this
  }
}).$mount('#app')
Rem.setFontSize();



// WEBPACK FOOTER //
// ./src/main.js